/* eslint-disable react/prop-types */
import {
	Alert,
	Button,
	Grid,
	Input,
	InputLabel,
	Snackbar,
	Typography,
	TextField,
	OutlinedInput,
	Modal,
	Box,
	IconButton,
	InputAdornment,
	Select,
	MenuItem,
} from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import React from 'react';

import { Link } from 'react-router-dom';

import { addPayer, getPayerById } from '../../../../services/api/apiManager';

import { useState, useEffect } from 'react';

import CancelIcon from '@mui/icons-material/Cancel';

import * as Yup from 'yup';
import {
	Add,
	ApartmentOutlined,
	BusinessOutlined,
	Call,
	FormatListBulletedOutlined,
	Inventory2Outlined,
	PersonOutline,
	PlaceOutlined,
} from '@mui/icons-material';
import MaskedInput from 'react-text-mask';
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 'min(820px, calc(100vw - 32px))',
	backgroundColor: 'white',
	border: '1px solid #dce8f5',
	borderRadius: '10px',
	boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
	outline: 'none',
};

function Addpayer(props) {
	const defaultTheme = createTheme();

	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [emptyField, setEmptyFieldError] = useState(false);
	const [openModal, setOpenModal] = useState(true);
	// Close Modal
	const handleCloseModal = () => {
		setOpenModal(false);
		if (props.onClose) {
			props.onClose();
		} else {
			// this prop sends data to the parent component so the payer list stays visible
			props.renderHandleFromChild('insurrance');
		}
	};
	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbar(false);
	};
	const handleSnackbaErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
	};
	const handleEmptyFieldError = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setEmptyFieldError(false);
	};
	const id = localStorage.practice_id;

	// const handleNameChange = (e) => {
	// 	const input = e.target.value;
	// 	const regex = /^[a-zA-Z\s]*$/;
	// 	if (regex.test(input) || input === '') {
	// 	  setPayer((prev) => ({ ...prev, Name: input }));
	// 	}
	//   };
	// const handleTypeChange = (e) => {
	// 	const input = e.target.value;
	// 	const regex = /^[a-zA-Z\s]*$/;
	// 	if (regex.test(input) || input === '') {
	// 	  setPayer((prev) => ({ ...prev, Type: input }));
	// 	}
	//   };
	// const handleCityChange = (e) => {
	// 	const input = e.target.value;
	// 	const regex = /^[a-zA-Z\s]*$/;
	// 	if (regex.test(input) || input === '') {
	// 	  setPayer((prev) => ({ ...prev, City: input }));
	// 	}
	//   };
	// const handleStateChange = (e) => {
	// 	const input = e.target.value;
	// 	const regex = /^[a-zA-Z\s]*$/;
	// 	if (regex.test(input) || input === '') {
	// 	  setPayer((prev) => ({ ...prev, State: input }));
	// 	}
	//   };

	const schema = Yup.object().shape({
		Name: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		Type: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Type should contain only alphabets'),
		// City: Yup.string().matches(
		// 	/^[a-zA-Z\s]+$/,
		// 	'City Name should contain only alphabets'
		// ),
		// State: Yup.string().matches(
		// 	/^[a-zA-Z]+$/,
		// 	'State Name should contain only alphabets'
		// ),
		// Contact: Yup.string().matches(
		// 	/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
		// 	'Invalid '
		// ),
		// Zip: Yup.string().matches(/^\d+$/, 'Numbers only '),
	});

	//   const handleKeyPress = (e) => {
	// 	const charCode = e.which ? e.which : e.keyCode;
	// 	if (
	// 	  charCode !== 32 && // allow space
	// 	  !(charCode >= 65 && charCode <= 90) && // allow uppercase letters
	// 	  !(charCode >= 97 && charCode <= 122) // allow lowercase letters
	// 	) {
	// 	  e.preventDefault();
	// 	}
	//   };

	const [payer, setPayer] = useState({
		Name: '',
		practice_id: id,
		Type: '',
		Contact: '',
		Address: '',
		City: '',
		State: '',
		Zip: '',
		Comments: '',
	});
	const addPayerData = async () => {
		try {
			// if (Object.values(payer).some((value) => value === '')) {
			// 	setEmptyFieldError(true);
			// 	return; // Exit function if any field is empty
			// }
			if (!payer?.Name || !payer?.Type) {
				setEmptyFieldError(true);
				return;
			}
			await schema.validate(payer, { abortEarly: false });

			const response = await addPayer(payer);
			if (response?.status === 201) {
				setPayer(true);
				setOpenSnackbar(true);
				handleCloseModal();
				// this props is sending data to parent for opening modal
				props.openSanckbarFromChild({
					openBar: true,
					barColor: 'green',
					snakbarFor: 'payer',
				});

				// setPayer(response?.data);
			} else if (response?.status === 400) {
				setOpenSnackbarError(true);
				handleCloseModal();
				props.openSanckbarFromChild({
					openBar: true,
					barColor: 'red',
					snakbarFor: 'payer',
				});
			} else {
				setOpenSnackbarError(true);
				handleCloseModal();
			}
		} catch (error) {
			console.error('Error updating user:', error);
		}
	};

	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setPayer((prev) => ({
			...prev,
			[name]: value,
		}));
		if (name === 'Name' || name === 'Type') {
			Yup.reach(schema, name)
				.validate(value)
				.then(() => {
					setErrors((prevErrors) => ({
						...prevErrors,
						[name]: '', // Clear error if validation passes
					}));
				})
				.catch((error) => {
					setErrors((prevErrors) => ({
						...prevErrors,
						[name]: error.message, // Set error message if validation fails
					}));
				});
		}
	};

	// const fetchPayer = async () => {
	// 	try {
	//
	// 		const response = await getPayerById();
	// 		if (response?.status === 200) {
	// 			setPayer(response?.data);
	// 		}
	// 		else
	// 		{
	// 			setPayer({});
	// 		}
	// 	} catch (error) {
	// 		console.error('Error fetching payer:', error);
	// 	}
	// };

	// const updatePayer = async () => {
	// 	try {
	// 		const response = await updatePayer(user);
	// 		if (response?.status === 200) {
	// 			setPayer(response?.data);
	// 		}
	// 		else
	// 		{
	// 			setPayer({});
	// 		}
	// 	} catch (error) {
	// 		console.error('Error updating user:', error);
	// 	}
	// };

	// useEffect(()=>{
	// 	fetchPayer();
	// },[])

	const labelSx = {
		fontFamily: 'Poppins',
		fontSize: '13px',
		fontWeight: 600,
		color: '#0b2450',
		mb: 0.8,
	};

	const fieldSx = {
		'& .MuiOutlinedInput-root': {
			height: '42px',
			borderRadius: '6px',
			fontFamily: 'Poppins',
			fontSize: '13px',
			color: '#0b2450',
			'& fieldset': { borderColor: '#d7e3f4' },
			'&:hover fieldset': { borderColor: '#b8c9df' },
			'&.Mui-focused fieldset': { borderColor: '#2f6edb' },
		},
		'& .MuiInputBase-input': {
			padding: '10px 14px',
		},
	};

	const multilineFieldSx = {
		...fieldSx,
		'& .MuiOutlinedInput-root': {
			...fieldSx['& .MuiOutlinedInput-root'],
			height: '96px',
			alignItems: 'flex-start',
		},
		'& .MuiInputBase-input': {
			padding: '12px 14px',
		},
	};

	const maskedInputStyle = {
		width: '100%',
		height: '42px',
		borderRadius: '6px',
		border: '1px solid #d7e3f4',
		padding: '10px 40px 10px 14px',
		outline: 'none',
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#0b2450',
		boxSizing: 'border-box',
	};

	const selectMenuProps = {
		PaperProps: {
			sx: {
				mt: 0.5,
				borderRadius: '6px',
				boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
				'& .MuiMenuItem-root': {
					fontFamily: 'Poppins',
					fontSize: '13px',
				},
			},
		},
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			{/* Darks code Start from here  */}
			{/* Modal Structure */}
			<Modal
				open={openModal}
				// onClose={handleCloseModal} // Close Modal When any screen click.
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box sx={style}>
					<Box
						sx={{
							height: '60px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							px: 2,
							borderBottom: '1px solid #edf2f8',
						}}
					>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '20px',
								fontWeight: 700,
								color: '#111827',
							}}
						>
							Add Payer
						</Typography>
						<IconButton onClick={handleCloseModal} sx={{ color: '#475569' }}>
							<CancelIcon sx={{ fontSize: '22px' }} />
						</IconButton>
					</Box>
					<Grid container spacing={2.2} sx={{ p: 2.4 }}>
						<Grid item lg={4} md={4} sm={12} xs={12}>
							<InputLabel sx={labelSx}>
								Payer Name <span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField name="Name" size="small" fullWidth value={payer?.Name} error={emptyField && payer?.Name == ''} onChange={handleInputChange} placeholder="Enter payer name" sx={fieldSx} InputProps={{ endAdornment: <InputAdornment position="end"><PersonOutline sx={{ color: '#7b8ba5', fontSize: 20 }} /></InputAdornment> }} />
							{errors.Name && <div style={{ color: 'red', fontSize: '10px' }}>{errors.Name}</div>}
						</Grid>
						<Grid item lg={4} md={4} sm={12} xs={12}>
							<InputLabel sx={labelSx}>
								Payer Type <span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<Select error={emptyField && payer?.Type == ''} name="Type" size="small" fullWidth displayEmpty value={payer?.Type} onChange={handleInputChange} sx={fieldSx} MenuProps={selectMenuProps} renderValue={(selected) => selected || <span style={{ color: '#8b9ab0' }}>Select payer type</span>}>
								<MenuItem value={'private'}>Private</MenuItem>
								<MenuItem value={'government'}>Government</MenuItem>
							</Select>
							{errors.Type && <div style={{ color: 'red', fontSize: '10px' }}>{errors.Type}</div>}
						</Grid>
						<Grid item lg={4} md={4} sm={12} xs={12}>
							<InputLabel sx={labelSx}>Contact</InputLabel>
							<Box sx={{ position: 'relative' }}>
								<MaskedInput required name="Contact" value={payer?.Contact} onChange={handleInputChange} placeholder="Enter contact name" mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]} style={maskedInputStyle} />
								<Call sx={{ color: '#7b8ba5', fontSize: 20, position: 'absolute', right: 12, top: 11 }} />
							</Box>
							{errors.Contact && <div style={{ color: 'red', fontSize: '10px' }}>{errors.Contact}</div>}
						</Grid>
						<Grid item xs={12}>
							<InputLabel sx={labelSx}>Address <span style={{ color: '#d61b1b' }}>*</span></InputLabel>
							<TextField name="Address" size="small" fullWidth value={payer?.Address} onChange={(e) => setPayer((prev) => ({ ...prev, Address: e.target.value }))} placeholder="Enter street address" sx={fieldSx} InputProps={{ endAdornment: <InputAdornment position="end"><PlaceOutlined sx={{ color: '#7b8ba5', fontSize: 20 }} /></InputAdornment> }} />
						</Grid>
						<Grid item lg={4} md={4} sm={12} xs={12}>
							<InputLabel sx={labelSx}>City <span style={{ color: '#d61b1b' }}>*</span></InputLabel>
							<TextField name="City" size="small" fullWidth value={payer?.City} onChange={handleInputChange} placeholder="Enter city" sx={fieldSx} InputProps={{ endAdornment: <InputAdornment position="end"><BusinessOutlined sx={{ color: '#7b8ba5', fontSize: 20 }} /></InputAdornment> }} />
							{errors.City && <div style={{ color: 'red', fontSize: '10px' }}>{errors.City}</div>}
						</Grid>
						<Grid item lg={4} md={4} sm={12} xs={12}>
							<InputLabel sx={labelSx}>State <span style={{ color: '#d61b1b' }}>*</span></InputLabel>
							<TextField name="State" size="small" fullWidth value={payer?.State} onChange={handleInputChange} placeholder="Select state" sx={fieldSx} InputProps={{ endAdornment: <InputAdornment position="end"><ApartmentOutlined sx={{ color: '#7b8ba5', fontSize: 20 }} /></InputAdornment> }} />
							{errors.State && <div style={{ color: 'red', fontSize: '10px' }}>{errors.State}</div>}
						</Grid>
						<Grid item lg={4} md={4} sm={12} xs={12}>
							<InputLabel sx={labelSx}>ZIP <span style={{ color: '#d61b1b' }}>*</span></InputLabel>
							<TextField name="Zip" size="small" fullWidth value={payer?.Zip} onChange={handleInputChange} placeholder="Enter ZIP code" sx={fieldSx} InputProps={{ endAdornment: <InputAdornment position="end"><Inventory2Outlined sx={{ color: '#7b8ba5', fontSize: 20 }} /></InputAdornment> }} />
							{errors.Zip && <div style={{ color: 'red', fontSize: '10px' }}>{errors.Zip}</div>}
						</Grid>
						<Grid item xs={12}>
							<InputLabel sx={labelSx}>Comments</InputLabel>
							<TextField name="Comments" multiline rows={3} fullWidth value={payer?.Comments} onChange={(e) => setPayer((prev) => ({ ...prev, Comments: e.target.value.slice(0, 500) }))} placeholder="Enter any additional comments (optional)" sx={multilineFieldSx} InputProps={{ endAdornment: <InputAdornment position="end" sx={{ alignSelf: 'flex-end', pb: 1 }}><FormatListBulletedOutlined sx={{ color: '#7b8ba5', fontSize: 20 }} /></InputAdornment> }} />
							<Typography sx={{ color: '#7b8ba5', fontFamily: 'Poppins', fontSize: '12px', mt: 0.6 }}>
								{payer?.Comments?.length || 0} / 500 characters
							</Typography>
						</Grid>
					</Grid>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							gap: 1.5,
							p: 2,
							borderTop: '1px solid #edf2f8',
						}}
					>
						<Button
							onClick={handleCloseModal}
							sx={{
								height: '40px',
								minWidth: 126,
								borderRadius: '6px',
								border: '1px solid #cfd8e6',
								color: '#2f4467',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
							}}
						>
							Cancel
						</Button>
						<Button
							startIcon={<Add />}
							sx={{
								height: '40px',
								minWidth: 142,
								borderRadius: '6px',
								backgroundColor: '#2f6edb',
								color: '#fff',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
								boxShadow: '0 4px 10px rgba(47, 110, 219, 0.2)',
								'&:hover': {
									backgroundColor: '#245fc5',
								},
							}}
							onClick={() => addPayerData()}
						>
							Add Payer
						</Button>
					</Box>
				</Box>
			</Modal>
			{/* Darks code ends here */}

			{/* snack bar for Patient added successfully */}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={3000} // Adjust the duration as needed
				onClose={handleSnackbarClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbarClose}
					severity="success"
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					New Payer Added Successfully
				</Alert>
			</Snackbar>
			{/* snack bar for 401 error  */}
			<Snackbar
				open={openSnackbarError}
				autoHideDuration={3000} // Adjust the duration as needed
				onClose={handleSnackbaErrorClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbaErrorClose}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '17px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					Error
				</Alert>
			</Snackbar>

			{/* snack bar for empty field  */}

			<Snackbar
				open={emptyField}
				autoHideDuration={3000} // Adjust the duration as needed
				onClose={handleEmptyFieldError}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleEmptyFieldError}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '14px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					Fill all the Fields
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default Addpayer;
